
  import { Vue, Component, Prop } from "vue-property-decorator";
  import { hslColorFromName } from "@/utils/hslColorFromName";
  import UiButton from "@/components/button/ui-button.vue";
  import S3Image from "@/components/common/s3-image.vue";

  @Component({
    components: {
      S3Image,
      UiButton
    },
  })
  export default class TableNotesAvatar extends Vue {
    @Prop({type: String, default: undefined}) readonly image?: string;
    @Prop({type: String, default: undefined}) readonly initial?: string;
    @Prop({type: String, default: undefined}) readonly title?: string;
    @Prop({type: String, default: undefined}) readonly firstNames?: string;
    @Prop({type: String, default: undefined}) readonly lastNames?: string;
    @Prop({type: String, default: undefined}) readonly subtitle?: string;
    @Prop({type: String,  default: undefined }) openDate?: string;
    @Prop({type: Boolean, default: false}) readonly clickable!: boolean;
    @Prop({type: Boolean, default: false}) readonly avatarOnly!: boolean;
    @Prop({type: Boolean, default: false}) readonly available!: boolean;
    @Prop({type: Boolean, default: false}) readonly primary!: boolean;
    @Prop({type: Boolean, default: false}) readonly highlightAvatar!: boolean;
    @Prop({type: String, default: "h-6 w-6"}) readonly avatarClasses!: string;
    @Prop({ type: String, default: undefined }) readonly notes!: string;
    note: String = "";
    showNote: boolean = false;
    get avatarStyleClasses(): Record<string, boolean> {
      return {
        [this.avatarClasses]: Boolean(this.avatarClasses),
        ["border border-primary customAvatar"]: this.highlightAvatar,
      };
    }
    viewMore(): void {
     this.note = this.notes;
     this.showNote = true;
    }
    get defaultInitialsClasses(): string {
      return "inline-flex h-6 w-6 rounded-full items-center justify-center";
    }

    get defaultImageClasses(): string {
      return "inline-block rounded-full object-cover object-center";
    }

    get bgStyle(): object {
      return {
        background: this.primary ? "#1A7BEE" : hslColorFromName(this.initial || ""),
      };
    }

    get ckickableClass(): string | undefined {
      if (!this.clickable) {
        return undefined;
      }
      
      return "cursor-pointer";
    }
  }
